import type { JSX } from 'react'
import type { IInputProps } from '../Input'

import { TextBoxColors, TextBoxTypes } from 'atoms/TextBox'
import { FIXED_INDENTS } from 'vars/fixed-indents'
import { Input } from '../Input'
import {
  InputBorders,
  InputFontColors,
  InputFonts,
  InputNames,
  InputPaddings,
} from '../Input.h'

export interface IAccountUsernameInputProps extends IInputProps {}

export const AccountUsernameInput = ({
  type = 'text',
  name = InputNames.Username,
  placeholder = '',
  placeholderColor = InputFontColors.TEXT_ICON_SECONDARY,
  label = '',
  labelFont = TextBoxTypes.FontXs,
  labelColorDefault: _unused = TextBoxColors.TEXT_ICON_SECONDARY,
  labelGap = FIXED_INDENTS.INDENT_10,
  font = InputFonts.FontXs,
  colorDefault = InputFontColors.TEXT_ICON_PRIMARY,
  required = true,
  paddings = InputPaddings.SIZE_20,
  borders = InputBorders.BORDER_10,
  inputWrapperWidth = '100%',
  inputWrapperHeight = '40px',
  autoComplete,
  ...rest
}: IAccountUsernameInputProps): JSX.Element => (
  <Input
    type={type}
    name={name}
    placeholder={placeholder}
    placeholderColor={placeholderColor}
    label={label}
    font={font}
    colorDefault={colorDefault}
    required={required}
    paddings={paddings}
    borders={borders}
    labelFont={labelFont}
    inputWrapperWidth={inputWrapperWidth}
    inputWrapperHeight={inputWrapperHeight}
    autoComplete={autoComplete}
    labelGap={labelGap}
    {...rest}
  />
)
